import Grid from '@material-ui/core/Grid';
import { TimePicker } from '@material-ui/pickers';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { gridMargin } from './general';

const viewportWidth = window.innerWidth;
const datePickerScaleSize = viewportWidth / 458; // change the reference width as necessary

const styles = () => {
	return {
		scaleForMobile: {
			scale: datePickerScaleSize,
		},
	};
};

class FormTimePicker extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			required,
			error,
			helpText,
			disabled,
			gridProps,
			minutesStep,
			format,
			shouldScaleForMobile,
		} = this.props;

		const _onChange = (date) => {
			onChange(moment(date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]'), path);
		};

		const hasError = !!error;
		const helperText = hasError ? error : helpText ? helpText : null;

		const content = (
			<TimePicker
				label={label}
				value={value || null}
				format={format || 'h:mm a'}
				onChange={_onChange}
				disabled={disabled}
				required={required}
				error={hasError}
				fullWidth={true}
				margin={'dense'}
				helperText={helperText}
				minutesStep={minutesStep}
				DialogProps={
					shouldScaleForMobile ? { className: this.props.classes.scaleForMobile } : undefined
				}
			/>
		);

		if (gridProps) {
			_.defaults(gridProps, { xs: 12 });
			return (
				<Grid item {...gridProps} style={gridMargin}>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FormTimePicker.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	helpText: PropTypes.string,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	gridProps: PropTypes.object,
	minutesStep: PropTypes.number,
};

FormTimePicker.defaultProps = {
	required: false,
	minuteStep: 1,
};

export default _.flow([withStyles(styles)])(FormTimePicker);
